import { Observable } from "rxjs"
import { ObservableFromFetch } from "../../ObservableFromFetch"

export interface ValidationResultRow {
  Cells: string[]
  Status: string
}

export interface ImportJobValidationResult {
  TableHeaderItems: string[]
  TableRows: ValidationResultRow[]
  TitleMessage?: string
  ImportMessage?: string
  OtherMessage?: string
  CancelImportMessage?: string
  CanBeImported: boolean
  ImportJobID: number
  Pages: number
  Total: number
}

export default function ImportJobValidationResultGetObservable(importJobID: number, pageNumber?: number, pageSize?: number, poolID?:number): Observable<ImportJobValidationResult> {
  const params: string = JSON.stringify({
    ImportJobID: importJobID,
    PageNumber: pageNumber || 1,
    PageSize: pageSize || 10,
    PoolID: poolID || 0
  })
  return ObservableFromFetch<ImportJobValidationResult>("WorkforceImport/GetImportFileValidationErrors", params)
}
